/** @format */

import React from 'react';
import { HEADERMENU_PATH } from '../../../../../routes/RoutesURL';

type Props = {
    leftSide: React.ReactNode;
    rightSide: React.ReactNode;
    id?: string;
    isAccount?: boolean;
};

const OnboardingMainContainer: React.FC<Props> = ({ leftSide, rightSide, id, isAccount }) => {
    const minHeight = window.location.pathname.includes(HEADERMENU_PATH.onboarding)
        ? 'calc(100vh)'
        : 'calc(100vh - 80px)';
    return (
        <div className="flex flex-col md:flex-row bg-[#F5F4F2]" style={{ minHeight: minHeight }} id={id}>
            <div className={` w-full md:w-1/3 lg:w-1/4 bg-white ${isAccount ? 'md:sticky' : ''}`} style={{ zIndex: 1 }}>
                {leftSide}
            </div>
            <div className={`w-full ${isAccount ? 'mt-0' : 'mt-0'} md:mt-0 md:w-2/3 lg:w-3/4 p-6  overflow-hidden`}>
                {rightSide}
            </div>
        </div>
    );
};

export default OnboardingMainContainer;
